import script from "./KytChainEmptyState.vue?vue&type=script&setup=true&lang=ts"
export * from "./KytChainEmptyState.vue?vue&type=script&setup=true&lang=ts"

import "./KytChainEmptyState.vue?vue&type=style&index=0&id=73840e01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73840e01"]])

export default __exports__